import clsx from "clsx";
import React, { useState } from "react";
import { useHistory } from "react-router";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import CallMadeIcon from "@material-ui/icons/CallMade";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import routes from "common/routes";
import Dialog from "components/Dialog/Dialog";
import CustomRaceIcon from "components/Icons/CustomRace";
import LastRaceIcon from "components/Icons/LastRace";
import Loader from "components/Loader";
import MatchesCount from "components/MatchesCount";
import { useRacehorse360Api } from "hooks/api";

import useCommonStyles from "../styles";
import useStyles from "./styles";

const MatchingHorsesBlock = () => {
  const commonClasses = useCommonStyles();
  const classes = useStyles();

  const history = useHistory();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { usePullTrainerHorsesWithMatchingRacesCount } = useRacehorse360Api();

  const { data, isLoading } = usePullTrainerHorsesWithMatchingRacesCount({});
  const matchingHorses: racehorse360.IHorseWithMatchingRacesCount[] =
    data?.horsesWithMatchingRacesCount || [];

  const handleMatchingHorseClick = (
    matchingHorse: racehorse360.IHorseWithMatchingRacesCount
  ) => {
    const horseId = matchingHorse.id;
    if (horseId) {
      history.push(routes.horseDetails.path.replace(":horseId", horseId));
    }
  };

  const handleMatchingHorsesClick = () => {
    matchingHorses?.length && setIsModalOpen(true);
  };

  const handleMatchingHorsesClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Grid
        container
        component={Paper}
        className={clsx(commonClasses.infoPaper, {
          [commonClasses.pointerAvailable]: matchingHorses?.length
        })}
        onClick={handleMatchingHorsesClick}
      >
        {isLoading && <Loader overlay />}
        <Grid
          item
          className={clsx(commonClasses.badge, classes.matchingHorsesBadge)}
        >
          <FormatListNumberedIcon className={commonClasses.badgeIcon} />
        </Grid>
        <Grid item>
          <Grid container className={commonClasses.blockContent}>
            <Grid
              component={Typography}
              item
              className={commonClasses.count}
              xs={12}
            >
              {matchingHorses?.length ?? 0}
            </Grid>
            <Grid
              component={Typography}
              item
              className={commonClasses.label}
              xs={12}
            >
              Matching Horses
            </Grid>
          </Grid>
        </Grid>
        {Boolean(matchingHorses?.length) && (
          <Box className={commonClasses.corner}>
            <CallMadeIcon className={commonClasses.cornerIcon} />
          </Box>
        )}
      </Grid>

      {isModalOpen && (
        <Dialog
          isOpen
          title={`${matchingHorses?.length} Horses Matching Races`}
          onClose={handleMatchingHorsesClose}
          className={classes.modalRoot}
        >
          {isLoading && <Loader className={classes.dialogLoader} />}
          <TableContainer>
            <Table>
              <TableBody>
                {matchingHorses?.map(horse => (
                  <TableRow
                    key={horse.id}
                    className={classes.tableMatchingHorseRow}
                    onClick={() => handleMatchingHorseClick(horse)}
                  >
                    <TableCell
                      className={clsx(
                        classes.tableMatchingHorseCell,
                        classes.tableMatchingHorseRacesCount
                      )}
                    >
                      <MatchesCount
                        matchedHorsesCount={horse.matchingRacesCount}
                      />
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableMatchingHorseCell,
                        classes.tableMatchingHorseName
                      )}
                    >
                      {horse.horseName}
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableMatchingHorseCell,
                        classes.tableMatchingHorsePreferredConditionsType
                      )}
                    >
                      {horse.areLastRacePreferredConditionsSelected ? (
                        <LastRaceIcon className={classes.lastRaceIconDetails} />
                      ) : (
                        <CustomRaceIcon className={classes.customIconDetails} />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
      )}
    </>
  );
};

export default React.memo(MatchingHorsesBlock);
